import { useNavigate } from 'react-router-dom';
import './course_view_module.css';
import { forwardRef } from "react";
import { useLang } from '../../context/LangContext';
import {ArticleTime} from '../ArticleTime/ArticleTime';

export const CourseViewModule = forwardRef(({module, isMember, courseId, course}, ref) => {
    const navigate = useNavigate();
    const { lang } = useLang();

    const goToArticle = (id) => {
        if (isMember) {
            navigate('/course/' + courseId + '/article/' + id, {replace: true, state: {course: course}});
        }

    }

    return (
        <>
            <div className='course_view_module'>
                <div className='module_title'>
                    <span>
                    { module.en && lang === "en" ? module.en.name : module.name }
                    </span>
                </div>
                <div className='module_articles'>
 
                    {
                        module.articles && module.articles.map((article) => {
                            return (

                            <div className='item-cont' key={'module_' + module.id + "_view_article_" + article.id} onClick={() => goToArticle(article.id)}>
                                <div className='item' >
                                   
                                    <i className="fa-solid fa-newspaper"></i>
                                    <span>
                                        { article.en && lang === "en" ? article.en.name : article.name } 
                                    </span>
                                </div>
                                <ArticleTime article={article}></ArticleTime>
                            </div>    
                                
                               
                            )
                        })
                    }
                </div>
            </div>
        </>
    );
});


